import React, { useEffect, useState } from "react";
import axios from "../api/axiosInstance";

export default function AdminCourierOrders() {

 const [cartOrders, setCartOrders] = useState([]);
const [rxOrders, setRxOrders] = useState([]);
  const [formData, setFormData] = useState({});

  // ---------------- LOAD ORDERS ----------------
const load = async () => {

  try {

    const cartRes = await axios.get(
      "/admin/pending-courier-orders/"
    );

    const rxRes = await axios.get(
      "/admin/pending-rx-courier-orders/"
    );

    setCartOrders(cartRes.data);

    setRxOrders(rxRes.data);

  }

  catch(err){

    console.error(err);

  }

};
  useEffect(() => {
    load();
  }, []);

  // ---------------- HANDLE INPUT ----------------

  const handleChange = (orderId, field, value) => {
    setFormData(prev => ({
      ...prev,
      [orderId]: {
        ...prev[orderId],
        [field]: value
      }
    }));
  };

  // ---------------- SUBMIT ----------------
const renderOrder = (order) => (

  <div
    key={order.id}
    style={{
      border: "1px solid #ddd",
      padding: 15,
      marginBottom: 20,
      borderRadius: 8
    }}
  >

    <p><b>Order ID:</b> {order.id}</p>

    <p><b>Customer:</b> {order.customer}</p>

    {order.type === "prescription" && (
      <p><b>Hospital:</b> {order.hospital}</p>
    )}

    <p><b>Distance:</b> {order.distance} km</p>

    <p>
      <b>
        {order.type === "prescription"
          ? "Medicine Total"
          : "Cart Total"}
      </b>
      : ₹{order.cart_total}
    </p>

    <hr />

    <input
      type="number"
      placeholder="Courier amount"
      onChange={(e)=>
        handleChange(
          order.id,
          "amount",
          e.target.value
        )
      }
    />

    <br /><br />

 <button
  disabled={formData[order.id]?.loading}
  onClick={() => handleSubmit(order.id, order.type)}
  style={{
    background: "#2563eb",
    color: "white",
    padding: "6px 12px",
    borderRadius: 4,
    border: "none",
    opacity: formData[order.id]?.loading ? 0.6 : 1,
    cursor: formData[order.id]?.loading ? "not-allowed" : "pointer"
  }}
>
  {formData[order.id]?.loading ? "Updating..." : "Confirm Courier"}
</button>

  </div>

);

const handleSubmit = async (orderId, type) => {

  const data = formData[orderId];

  if (!data?.amount) {
    alert("Enter courier amount");
    return;
  }
setFormData(prev => ({
    ...prev,
    [orderId]: {
      ...prev[orderId],
      loading: true
    }
  }));
try{
  if (type === "cart") {

    await axios.post(
      "/admin/set-courier-charge/",
      {
        order_id: orderId,
        amount: data.amount,
        estimated_message:
          data.estimated_message || "",
        note: data.note || ""
      }
    );

  }

  else {

    await axios.post(
      "/admin/set-rx-courier-charge/",
      {
        order_id: orderId,
        amount: data.amount,
        estimated_message:
          data.estimated_message || "",
        note: data.note || ""
      }
    );

  }


  alert("Courier updated successfully");

  load();
}
catch (err) {
    alert(err.response?.data?.error || "Error updating courier ❌");
  }
setFormData(prev => ({
    ...prev,
    [orderId]: {
      ...prev[orderId],
      loading: false
    }
  }));

};

  // ---------------- UI ----------------
const box = {

 background: "#f3f4f6",
 padding: 20,
 borderRadius: 8,
 marginTop: 20

};
 return (

<div style={{ padding: 20 }}>


  <h2>🛒 Cart Courier Orders</h2>


  {cartOrders.length === 0 && (

    <div style={box}>
      No cart courier orders
    </div>

  )}


  {cartOrders.map(order =>
    renderOrder({
      ...order,
      type: "cart"
    })
  )}



  <h2 style={{ marginTop: 40 }}>
    🏥 Hospital Prescription Courier Orders
  </h2>


  {rxOrders.length === 0 && (

    <div style={box}>
      No prescription courier orders
    </div>

  )}


  {rxOrders.map(order =>
    renderOrder({
      ...order,
      type: "prescription"
    })
  )}


</div>

);
}
